import React from "react";
import letterdirector from "../../img/letterdirector.jpeg";
import moi from "../../img/moi.jpeg";
import bona from "../../img/bona.jpeg";
import rainure from "../../img/rainure.jpeg";

const Images = () => {
  return (
    <>
      <div className="fulldoc">
        <h1 className="doc">Documents</h1>
        <img src={letterdirector} className="img-fluid" alt="..." />
        <img src={moi} className="img-fluid" alt="..." />
        <img src={bona} className="img-fluid" alt="..." />
        <img src={rainure} className="img-fluid" alt="..." />
      </div>
    </>
  );
};

export default Images;
